// Dedicated SEO content for individual service pages (/services/:slug)
export const serviceContent = {
  "roof-repair": {
    name: "Roof Repair",
    h1: "Roof Repair in Northern Virginia, D.C. & Maryland",
    metaTitle: "Roof Repair Vienna VA & Northern Virginia | Fab Build Pro",
    metaDesc:
      "Fast, reliable roof repair across Northern Virginia, D.C. & Maryland. Leak repair, shingle replacement & storm damage. Free inspections. Call 703-766-6599.",
    image: "/img/roof-repair.webp",
    intro: [
      "A small roof problem rarely stays small. A few missing shingles or a minor leak can quickly lead to rotted decking, ruined insulation, and interior water damage. Fab Build Pro provides fast, dependable roof repair throughout Northern Virginia, Washington D.C., and Maryland — restoring your roof and your peace of mind.",
      "Our experienced crews repair asphalt, architectural, metal, and flat roofs. From a single leak to storm-related damage, we diagnose the real cause (not just the symptom) and fix it right the first time, backed by our workmanship guarantee.",
    ],
    benefits: [
      "Free, no-obligation roof inspections with photo documentation",
      "Leak detection, shingle & flashing repair, and emergency tarping",
      "Fast response — often within 24–48 hours",
      "Licensed, insured & GAF Master Elite certified",
      "Honest repair-vs-replace recommendations",
    ],
    faqs: [
      { q: "How much does a roof repair cost?", a: "Most minor roof repairs range from $300 to $1,500 depending on the damage, materials, and roof access. We provide a free inspection and written quote before any work begins." },
      { q: "Can you repair just part of my roof?", a: "Yes. If the surrounding roof is in good shape, a targeted repair is often the most cost-effective solution. We'll always give you an honest assessment." },
      { q: "Do you offer emergency roof repair?", a: "Yes — we offer 24/7 storm response and can tarp or secure an active leak quickly across the DMV. Call 703-766-6599." },
    ],
  },
  "roof-replacement": {
    name: "Roof Replacement",
    h1: "Roof Replacement & Installation in the DMV",
    metaTitle: "Roof Replacement Vienna VA & Northern VA | Fab Build Pro",
    metaDesc:
      "Roof replacement & installation across Northern Virginia, D.C. & Maryland. GAF Master Elite warranties & financing. Call 703-766-6599.",
    image: "/img/hero-6.webp",
    intro: [
      "When repairs are no longer enough, a full roof replacement protects your home for decades and adds real value. As a GAF Master Elite contractor, Fab Build Pro installs premium roofing systems with enhanced manufacturer warranties available to only the top 2% of roofers nationwide.",
      "We handle everything — tear-off, decking inspection, underlayment, ventilation, and clean-up — with crews that treat your home like their own. Most residential roofs are completed in 1–2 days.",
    ],
    benefits: [
      "Premium asphalt, architectural, designer & metal roofing options",
      "Enhanced GAF warranties up to 50 years on qualifying systems",
      "Flexible financing, 0% options & 100% price match",
      "Insurance claim assistance for storm-related replacements",
      "Thorough clean-up and magnetic nail sweep",
    ],
    faqs: [
      { q: "How much does a new roof cost?", a: "Most replacements in the DMV range from $8,000 to $25,000 depending on size, pitch, and materials. We offer free estimates and flexible financing." },
      { q: "How long does a roof replacement take?", a: "Most homes are completed in 1–2 days depending on size and weather." },
      { q: "Will insurance cover my roof replacement?", a: "If storm or hail damage is involved, often yes. We handle the claim end to end and many homeowners pay little beyond their deductible." },
    ],
  },
  "roof-maintenance": {
    name: "Roof Maintenance",
    h1: "Roof Maintenance Services in Northern Virginia",
    metaTitle: "Roof Maintenance Northern Virginia | Fab Build Pro",
    canonicalPath: "/roof-maintenance",
    metaDesc:
      "Extend your roof's life with professional roof maintenance in the DMV. Inspections, tune-ups & preventative care. Free assessment. Call 703-766-6599.",
    image:
      "https://customer-assets.emergentagent.com/job_fabb-zip-search/artifacts/o5poyoyv_Top-Roof-Maintenance-Tips-You-Need-To-Know--rgx0v5bd8fcssx2rxgdpec6vz53hpll41q25w2jcds.webp",
    intro: [
      "Regular roof maintenance is the smartest, most affordable way to protect your home. A maintained roof lasts significantly longer, prevents costly leaks, and keeps your warranty valid. In the DMV — with humid summers, severe storms, and winter freeze-thaw cycles — proactive care makes a real difference.",
      "Fab Build Pro's roof maintenance service includes a thorough inspection, minor repairs, sealing, debris removal, and gutter checks so small issues are caught before they become expensive problems.",
    ],
    benefits: [
      "Annual & post-storm roof inspections",
      "Shingle, flashing & sealant tune-ups",
      "Gutter and downspout checks",
      "Photo-documented condition reports",
      "Extends roof lifespan & protects warranties",
    ],
    faqs: [
      { q: "How often should I have my roof inspected?", a: "At least once a year, and after any major storm. Regular inspections catch small issues early and can extend your roof's life by years." },
      { q: "What does roof maintenance include?", a: "A full inspection, minor repairs, resealing, debris and gutter clearing, and a photo report of your roof's condition with recommendations." },
      { q: "Is roof maintenance worth it?", a: "Absolutely. Preventative maintenance is a fraction of the cost of major repairs or premature replacement, and helps keep manufacturer warranties valid." },
    ],
  },
  roofing: {
    name: "Roofing Services",
    h1: "Roofing Contractor in Northern Virginia — Roof Repair & Replacement",
    metaTitle: "Roofing Contractor Northern Virginia | Fab Build Pro",
    metaDesc:
      "Roofing contractor in Vienna, VA serving Northern Virginia, D.C. & Maryland: roof repair, replacement, storm damage & maintenance. Call 703-766-6599.",
    image: "/img/reviews.webp",
    intro: [
      "Fab Build Pro is a full-service residential and commercial roofing contractor serving Northern Virginia and the entire DMV. From roof repair and replacement to storm and wind damage restoration, inspections, and maintenance, we deliver quality craftsmanship backed by strong warranties and a 100% satisfaction guarantee.",
      "As a GAF Master Elite certified contractor — a distinction held by only the top 2% of roofers nationwide — we offer premium materials and enhanced warranties, with transparent pricing and flexible financing options for every budget. Call 703-766-6599 for a free inspection.",
    ],
    benefits: [
      "Roof replacement & new installation",
      "Roof repair & leak repair",
      "Storm & wind damage repair",
      "Roof inspections & maintenance",
      "GAF Master Elite certified crews",
      "Free inspections & written estimates",
    ],
    faqs: [
      { q: "What roofing services do you offer?", a: "Roof replacement and new installation, roof repair and leak repair, storm and wind damage restoration, roof inspections, and preventative maintenance — for both residential and commercial roofs." },
      { q: "How much does a new roof cost in Northern Virginia?", a: "Most replacements in the DMV range from $8,000 to $25,000+ depending on size, pitch, and materials. We offer free inspections, written estimates, and flexible financing including 0% options." },
      { q: "What roofing materials do you install?", a: "Asphalt architectural shingles, designer/luxury shingles, metal roofing, and flat/low-slope systems (TPO, EPDM)." },
      { q: "Are you licensed and insured?", a: "Yes — licensed and insured in VA, D.C., and MD, and GAF Master Elite certified." },
      { q: "Do you offer free estimates?", a: "Yes, every inspection and estimate is 100% free with no obligation. Call 703-766-6599 to schedule." },
    ],
  },
  "storm-damage-repairs": {
    name: "Storm Damage Repairs",
    h1: "Storm & Wind Damage Roof Repair in Northern Virginia",
    metaTitle: "Storm Damage Repair & Insurance Claims NoVA | Fab Build Pro",
    metaDesc:
      "Storm & wind damage roof repair across Northern Virginia & the DMV. Insurance claim specialists — often little out-of-pocket cost. Call 703-766-6599.",
    image:
      "https://customer-assets.emergentagent.com/job_fabb-zip-search/artifacts/fc6e53pk_How-Storm-Damage-Shows-Up-on-Your-Roof.webp",
    intro: [
      "Severe storms, high winds, and hail can damage even a newer roof — and the damage isn't always visible from the ground. Fab Build Pro are storm-restoration specialists serving Northern Virginia, D.C., and Maryland, and we handle the entire insurance claim process for you.",
      "We document damage the way adjusters expect, meet them on-site, and restore your roof to code with premium materials. Many homeowners qualify for repair or full replacement with little more than their deductible.",
    ],
    benefits: [
      "Free storm & wind damage inspections",
      "Full insurance claim assistance, start to finish",
      "Emergency tarping & rapid response",
      "Hail, wind, and debris damage specialists",
      "Little or no out-of-pocket cost for many claims",
    ],
    faqs: [
      { q: "How do I know if my roof has storm damage?", a: "Look for lifted or missing shingles, granules in gutters, dented flashing, and interior water stains. Our free inspection finds hidden wind and hail damage." },
      { q: "Will you work with my insurance company?", a: "Yes. We manage the claim from inspection through completion and meet your adjuster on-site." },
      { q: "How quickly can you respond after a storm?", a: "We offer 24/7 storm response and can typically inspect and secure your roof within 24–48 hours." },
    ],
  },
  siding: {
    name: "Siding",
    h1: "Siding Installation & Replacement in the DMV",
    metaTitle: "Siding Contractor Northern Virginia | Fab Build Pro",
    metaDesc:
      "Vinyl, fiber cement & engineered wood siding installation across Northern Virginia, D.C. & Maryland. Boost curb appeal & efficiency. Call 703-766-6599.",
    image: "/img/team-siding.webp",
    intro: [
      "New siding transforms your home's curb appeal while protecting it from the elements. Fab Build Pro installs vinyl, insulated vinyl, fiber cement, and engineered wood siding built to withstand the DMV's humidity and storms.",
      "We help you choose the right material for your home, style, and budget — and install it with the same craftsmanship and guarantees as our roofing work.",
    ],
    benefits: [
      "Vinyl, insulated vinyl, fiber cement & engineered wood",
      "Improved energy efficiency & weather protection",
      "Wide range of colors, textures & profiles",
      "Pairs with roofing for a 25%-off bundle special",
      "Licensed, insured & fully warrantied",
    ],
    faqs: [
      { q: "What siding lasts longest in the DMV?", a: "Fiber cement and insulated vinyl both perform exceptionally well against Mid-Atlantic humidity and storms." },
      { q: "Can new siding lower my energy bills?", a: "Yes — insulated siding improves your home's thermal envelope and can reduce heating and cooling costs." },
      { q: "How long does siding installation take?", a: "Most homes take 3–7 days depending on size, material, and any repairs needed." },
    ],
  },
  windows: {
    name: "Windows",
    h1: "Window Installation & Replacement Services",
    metaTitle: "Replacement Windows Northern Virginia | Fab Build Pro",
    metaDesc:
      "Energy-efficient replacement & new-construction windows across Northern Virginia & the DMV. Cut energy loss & noise. Free estimates. Call 703-766-6599.",
    image:
      "https://customer-assets.emergentagent.com/job_fabb-zip-search/artifacts/nvba293c_Expert-Window-Installation-and-Replacement-expert.webp",
    intro: [
      "New windows improve comfort, curb appeal, and energy efficiency. Fab Build Pro installs both retrofit (replacement) and new-construction windows, with ENERGY STAR-rated, low-E glass options that cut energy loss and reduce outside noise.",
      "We'll help you choose the right style and configuration for your home and install them for a clean, weather-tight, lasting fit.",
    ],
    benefits: [
      "Retrofit & new-construction windows",
      "ENERGY STAR, double & triple-pane, low-E glass",
      "Reduced energy bills & outside noise",
      "Many styles, finishes & configurations",
      "Professional, weather-tight installation",
    ],
    faqs: [
      { q: "What's the difference between retrofit and new-construction windows?", a: "Retrofit windows fit your existing frame with minimal disruption; new-construction windows attach to framing and are used for additions or opened walls." },
      { q: "Are your windows energy efficient?", a: "Yes — we offer ENERGY STAR-rated windows with low-E glass and insulated frames." },
      { q: "Do you offer free window estimates?", a: "Yes, all estimates are free with no obligation." },
    ],
  },
  doors: {
    name: "Doors",
    h1: "Door Installation & Replacement",
    metaTitle: "Door Installation Northern Virginia | Fab Build Pro",
    metaDesc:
      "Entry, patio & storm door installation across Northern Virginia & the DMV. Steel, fiberglass & wood options. Free estimates. Call 703-766-6599.",
    image: "/img/doors.webp",
    intro: [
      "The right door adds security, energy efficiency, and curb appeal to your home. Fab Build Pro offers entry, patio, and storm doors in steel, fiberglass, and wood, in a wide range of styles, finishes, and glass options.",
      "We handle proper installation for a secure, weather-tight fit that looks great and lasts.",
    ],
    benefits: [
      "Entry, patio & storm doors",
      "Steel, fiberglass & wood options",
      "Energy-efficient & security-focused choices",
      "Wide range of styles & finishes",
      "Professional, weather-tight installation",
    ],
    faqs: [
      { q: "What door materials do you offer?", a: "Steel, fiberglass, and wood doors in many styles, including energy-efficient and security options." },
      { q: "Can you install storm doors?", a: "Yes — we install entry, patio, and storm doors throughout the DMV." },
      { q: "Do you provide free estimates for doors?", a: "Yes, all estimates are free." },
    ],
  },
  gutters: {
    name: "Gutters",
    h1: "Gutter Repair, Replacement & Guards in Northern Virginia",
    metaTitle: "Gutter Repair & Replacement Northern VA | Fab Build Pro",
    metaDesc:
      "Seamless gutter installation, repair & gutter guards across Northern Virginia & the DMV. Protect your home from water damage. Call 703-766-6599.",
    image:
      "https://customer-assets.emergentagent.com/job_fabb-zip-search/artifacts/2a9r0pas_Professional-Gutter-Repair-Replacement-and-Maintenance.webp",
    intro: [
      "Gutters protect your roof, siding, and foundation by channeling water away from your home. Fab Build Pro provides seamless gutter installation, repair, and gutter guard systems across Northern Virginia and the DMV.",
      "Our seamless aluminum gutters are custom-formed on-site to minimize leaks, and our gutter guards keep debris out to reduce maintenance and prevent overflow.",
    ],
    benefits: [
      "Seamless aluminum gutter installation",
      "Gutter repair & replacement",
      "Gutter guard / leaf protection systems",
      "Protects roof, siding & foundation",
      "Free assessment with any inspection",
    ],
    faqs: [
      { q: "How do I know if my gutters need replacing?", a: "Sagging, rust, cracks, peeling paint, pooling water, and frequent overflow are all signs. Gutters over 20 years old are usually best replaced." },
      { q: "Are gutter guards worth it?", a: "Yes — they dramatically reduce cleaning and prevent clogs and overflow that can damage your home." },
      { q: "Do you install seamless gutters?", a: "Yes, we form seamless aluminum gutters on-site for a leak-resistant, long-lasting fit." },
    ],
  },
  remodeling: {
    name: "Remodeling Services",
    h1: "Home Remodeling & Additions in the DMV",
    metaTitle: "Home Remodeling Contractor Northern Virginia | Fab Build Pro",
    metaDesc:
      "Kitchen, bathroom & whole-home remodeling plus additions across Northern Virginia & the DMV. Free consultations & financing. Call 703-766-6599.",
    image: "/img/remodeling.webp",
    intro: [
      "From kitchens and bathrooms to whole-room renovations and additions, Fab Build Pro is your full-service remodeling contractor in the DMV. We handle demo, remodel, and build-out with the same craftsmanship and transparency as our exterior work.",
      "We provide free consultations, clear written estimates, and financing options to bring your project to life.",
    ],
    benefits: [
      "Kitchen & bathroom remodels",
      "Room renovations & additions",
      "Decks, patios & exterior projects",
      "Full demo-and-rebuild services",
      "Free consultations & financing",
    ],
    faqs: [
      { q: "What remodeling projects do you handle?", a: "Kitchens, bathrooms, room renovations, additions, decks/patios, and full demo-and-rebuild projects." },
      { q: "Do you provide free remodeling estimates?", a: "Yes — free consultations and written estimates with transparent pricing and financing options." },
      { q: "Are you licensed and insured for remodeling?", a: "Yes, we are fully licensed and insured across VA, D.C., and MD." },
    ],
  },
};

export const serviceSlugs = Object.keys(serviceContent);
export const getServiceContent = (slug) => serviceContent[slug];
